//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FamilyAdd from './FamilyAdd';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Family',
  components: { FamilyAdd },
  data() {
    return {
      dlgShow: false,
      editMode: false,
      currentItem: {},
    };
  },
  computed: {
    ...mapGetters('personal', ['basicData']),
    dataForInfoList() {
      return this.basicData.userFamilyInfoList;
    },
  },
  methods: {
    ...mapActions('personal', ['setFamilyList']),
    handleDeleteFamily(payload) {
      this.$api('userDeleteFamily', payload).then(() => {
        this.$message.success('刪除成功!');
        this.getCustomerFamilyInfoList();
      });
    },
    getCustomerFamilyInfoList() {
      this.$api('userGetFamilyList').then(data => {
        this.setFamilyList(data);
      });
    },
    openAdd() {
      this.currentItem = {};
      this.editMode = false;
      this.dlgShow = true;
    },
    editFamily(row) {
      this.currentItem = row;
      this.editMode = true;
      this.dlgShow = true;
    },
    deleteFamily(row) {
      this.$confirm('是否刪除此家庭成員？', '提示', {
        type: 'warning',
      }).then(() => {
        const payload = {
          id: row.id,
        };
        this.handleDeleteFamily(payload);
      });
    },
    handleCommand(command) {
      command();
    },
  },
};
